import React from "react";
import Fade from "react-reveal/Fade";
import {
  ShieldCheck,
  Globe2,
  Ticket,
  Trophy,
  Users,
} from "lucide-react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../../theme/colors";

const HeroStats = ({
  bookies,
  lotteries,
  buytotal,
  draws,
  wins,
}) => {
  const stats = [
    {
      title: "Creators",
      value: bookies,
      icon: ShieldCheck,
    },
    {
      title: "Lotteries",
      value: lotteries,
      icon: Globe2,
      },
    {
      title: "Tickets Sold",
      value: buytotal,
      icon: Ticket,
    },
    {
      title: "Draws",
      value: draws,
      icon: Trophy,
    },
    {
      title: "Wins",
      value: wins,
      icon: Users,
    },
  ];

  return (
    <Box
      className="home-hero-stats"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "42px",
        flexWrap: "wrap",
        m: "5px 0",
      }}
    >
      {stats.map((stat, index) => {
        const Icon = stat.icon;

        return (
          <Fade
            key={stat.title}
            bottom
            delay={(index + 1) * 100}
          >
            <Box
              className="hero-stat-item"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                minWidth: "90px",
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.85)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: "8px",
                }}
              >
                <Icon
                  size={30}
                  strokeWidth={1.8}
                  color={colors.primary.main}
                />
              </Box>

              {/* Title */}
              <Typography
                component="p"
                sx={{
                  margin: 0,
                  fontFamily: "inherit",
                  fontSize: "13px",
                  fontWeight: 700,
                  letterSpacing: "0.6px",
                  color: "#14212B !important",
                  lineHeight: "1.3",
                }}
              >
                {stat.title}
              </Typography>

              {/* Number */}
              <Typography
                component="span"
                sx={{
                  marginTop: "5px",
                  fontFamily: "inherit",
                  fontSize: "13px",
                  fontWeight: 400,
                  color: "#71808A !important",
                  lineHeight: "1.3",
                }}
              >
                {stat.value}
              </Typography>
            </Box>
          </Fade>
        );
      })}
    </Box>
  );
};

export default HeroStats;